<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1c"><a id="page_xii"></a><a id="page_xiii"></a>E<span class="small">SSENTIAL</span> I<span class="small">SRAEL</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle01.vue?639d15b8